import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to the top on page change, or to the #hash target once it has rendered.
const ScrollManager = () => {
  const { pathname, hash, key } = useLocation();
  const previousPath = useRef(pathname);

  useEffect(() => {
    const samePage = previousPath.current === pathname;
    previousPath.current = pathname;

    if (!hash) {
      if (!samePage) window.scrollTo({ top: 0, behavior: "instant" });
      return undefined;
    }

    let attempts = 0;
    let frame;
    const tryScroll = () => {
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (target) {
        // Same page: let CSS scroll-behavior animate (and respect reduced motion).
        target.scrollIntoView(samePage ? undefined : { behavior: "instant" });
      } else if (attempts++ < 30) {
        frame = requestAnimationFrame(tryScroll);
      }
    };
    tryScroll();
    return () => cancelAnimationFrame(frame);
  }, [pathname, hash, key]);

  return null;
};

export default ScrollManager;
